import { render, staticRenderFns } from "./DashboardContainer.vue?vue&type=template&id=6e670d08"
import script from "./DashboardContainer.vue?vue&type=script&lang=ts"
export * from "./DashboardContainer.vue?vue&type=script&lang=ts"
import style0 from "./DashboardContainer.vue?vue&type=style&index=0&id=6e670d08&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports